import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from 'js/components/shared/Button';
import {searchBox} from '../../drupalSettings';
import ModuleByKey from '../../components/ModuleByKey';

import styles from './SearchViewFull.module.scss';

const cx = classnames.bind(styles);
const wordings = searchBox?.titles;

const SearchViewFull = function ({
  className,
  modules,
  onSubmit,
  onModuleChange,
  loading = false,
}) {

  const onSubmitClick = function (e) {
    e.preventDefault();
    e.stopPropagation();

    onSubmit && onSubmit();
  };

  return (
    <div className={cx('root', className)}>
      {modules.map((module, i) => (
        <ModuleByKey
          info={module}
          key={i}
          onChange={onModuleChange}
          className={cx('module')}
        />
      ))}
      <Button
        type="submit"
        size="xl"
        theme="squared"
        loading={loading}
        className={cx('submit')}
        onClick={onSubmitClick}
      >
        {wordings.searchButtonValue}
      </Button>
    </div>
  )
}

SearchViewFull.propTypes = {
  data: PropTypes.any
}

export default SearchViewFull;
